<div class="container w-100 mt-5">
    <div class="row">
        <div class="col-lg-6">
            <apx-chart [series]="labTestChart.series" [chart]="labTestChart.chart" [title]="labTestChart.title"
                [xaxis]="labTestChart.xAxis"></apx-chart>
        </div>
    </div>